import { render, staticRenderFns } from "./ManageReferee.vue?vue&type=template&id=e6c48886&"
import script from "./ManageReferee.vue?vue&type=script&lang=js&"
export * from "./ManageReferee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports